<script lang="ts">
  /**
   * How to install by hand, for a browser that offers no install prompt of
   * its own (Safari on iPhone and iPad: Share, then Add to Home Screen). The
   * steps arrive already in the game's language; the sheet numbers them.
   */
  import Sheet from './Sheet.svelte';

  interface Props {
    readonly open: boolean;
    readonly title: string;
    readonly intro?: string | undefined;
    readonly steps: readonly string[];
    readonly onclose: () => void;
    readonly testid?: string | undefined;
  }
  const { open, title, intro, steps, onclose, testid }: Props = $props();
</script>

<Sheet {open} {title} {onclose} {testid}>
  {#if intro !== undefined}
    <p class="ui-install-intro">{intro}</p>
  {/if}
  <ol class="ui-install-steps">
    {#each steps as step, index (index)}
      <li>
        <span class="ui-install-step-n" aria-hidden="true">{index + 1}</span>
        <span>{step}</span>
      </li>
    {/each}
  </ol>
</Sheet>

<style>
  .ui-install-intro {
    margin: 0 0 var(--ui-space-3);
    font: var(--ui-text-label);
    font-weight: 400;
    line-height: 1.45;
    color: var(--ui-ink-2);
  }

  .ui-install-steps {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--ui-space-3);
  }

  .ui-install-steps li {
    display: flex;
    align-items: center;
    gap: var(--ui-space-3);
    font: var(--ui-text-body);
    font-weight: 700;
    color: var(--ui-ink);
  }

  .ui-install-step-n {
    flex: 0 0 auto;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--ui-accent);
    color: var(--ui-on-accent);
    font-weight: 800;
  }
</style>
